import { t } from "i18next";
import { useState, useEffect } from "react";
import InputNumbers from "../numbers/InputNumbers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowsRepeat,
    faCheckCircle,
    faCircleQuestion,
    faLinkSimple,
    faLinkSimpleSlash,
} from "@fortawesome/pro-regular-svg-icons";
import "./InputResolution.scss";
import { Resolution } from "userful-chronos-app-common-js/dist/models/display";
import Button from "../../../button/Button";
import { useTranslation } from "react-i18next";
import UserfulTooltip from "../../../Widgets/UserfulTooltip";

interface IProps {
    onChange?(value: { width: string; height: string }): void;
    error?: boolean | undefined;
    success?: boolean | undefined;
    postchildren?: React.ReactNode | undefined;
    prechildren?: React.ReactNode | undefined;
    initvalue?: Resolution;
}

const InputResolution = ({ onChange, ...props }: IProps) => {
    const [value, setValue] = useState<{ width: string; height: string }>({
        width: props.initvalue ? `${props.initvalue.width}` : "1920",
        height: props.initvalue ? `${props.initvalue.height}` : "1080",
    });

    const [preserveRatio, setPreserveRatio] = useState<boolean>(false);
    const [aspectRatio, setAspectRatio] = useState<number>(1);

    const { t } = useTranslation();

    useEffect(() => {
        // console.log(value);
        if (onChange) onChange(value);
    }, [value]);

    const handleWidthChange = (newValue: string) => {
        // console.log(preserveRatio);
        if (preserveRatio) {
            setValue({ width: newValue, height: +newValue / aspectRatio + "" });
        } else {
            setValue({ ...value, width: newValue });
        }
    };
    const handleHeightChange = (newValue: string) => {
        // console.log(preserveRatio);
        if (preserveRatio) {
            setValue({ width: +newValue * aspectRatio + "", height: newValue });
        } else {
            setValue({ ...value, height: newValue });
        }
    };
    const handleSwap = (e) => {
        // console.log(value);
        setValue({ width: value.height, height: value.width });
    };
    const handlePreserveToggle = (e) => {
        // console.log(preserveRatio);

        if (!preserveRatio) {
            // console.log(value);

            if (value.height === "0" || value.width === "0") {
                setAspectRatio(1);
            } else {
                setAspectRatio(+value.width / +value.height);
            }
        }
        setPreserveRatio(!preserveRatio);
    };

    return (
        <div className="input-field-main-wrapper">
            <div className="input-resolution-wrapper">
                <InputNumbers
                    hideNumbers
                    filedtitle={t("Shared.resolutionWidth")}
                    forcevalue={value.width}
                    minValue={1}
                    onChange={(v) => handleWidthChange(v)}
                />
                <UserfulTooltip title={t("Shared.preserveRatio")}>
                    <Button
                        active={preserveRatio}
                        variant={"secondary"}
                        iconOnly
                        onClick={(e) => handlePreserveToggle(e)}
                    >
                        <FontAwesomeIcon icon={preserveRatio ? faLinkSimple : faLinkSimpleSlash} />
                    </Button>
                </UserfulTooltip>
                <InputNumbers
                    hideNumbers
                    filedtitle={t("Shared.resolutionHeight")}
                    forcevalue={value.height}
                    minValue={1}
                    onChange={(v) => handleHeightChange(v)}
                />
                <UserfulTooltip title={t("Shared.swapValues")}>
                    <Button variant={"secondary"} iconOnly onClick={handleSwap}>
                        <FontAwesomeIcon icon={faArrowsRepeat} />
                    </Button>
                </UserfulTooltip>
            </div>

            {props.postchildren && (
                <div
                    className={`input-field-container ${props.error ? "input-field-error" : ""}${props.success ? "input-field-success" : ""}`}
                >
                    {/* <div className="blue-badge-needs-to-be-replaced noselect">
                    <p>{t("Shared.aspectRatio")}{" "}{Math.round(aspectRatio * 1e5) / 1e5}</p>
                </div> */}
                    {props.error && <FontAwesomeIcon icon={faCircleQuestion} />}
                    {props.success && <FontAwesomeIcon icon={faCheckCircle} />}
                    {props.postchildren}
                </div>
            )}
        </div>
    );
};
export default InputResolution;
